export var IContentDocActionTypes;
(function (IContentDocActionTypes) {
    IContentDocActionTypes["SET_INITIAL_TEMPLATE_SLUG"] = "SET_INITIAL_TEMPLATE_SLUG";
    IContentDocActionTypes["REMOVE_IDLE_ANIMATION"] = "REMOVE_IDLE_ANIMATION";
    IContentDocActionTypes["REMOVE_IDLE_POSE_TIME"] = "REMOVE_IDLE_POSE_TIME";
    IContentDocActionTypes["SET_ANALYTICS_TRACKING"] = "SET_ANALYTICS_TRACKING";
    IContentDocActionTypes["CLEAR_SCREEN_SCENE_CONTENT"] = "CLEAR_SCREEN_SCENE_CONTENT";
    IContentDocActionTypes["COPY_SCREEN_SCENE_CONTENT"] = "COPY_SCREEN_SCENE_CONTENT";
    IContentDocActionTypes["SET_WEB_EMBED_CN_DOC"] = "SET_WEB_EMBED_CN_DOC";
    IContentDocActionTypes["REPLACE_ENTITY_CN_DOC"] = "REPLACE_ENTITY_CN_DOC";
    IContentDocActionTypes["ADD_BUTTON_CN_DOC"] = "ADD_BUTTON_CN_DOC";
    IContentDocActionTypes["ADD_TEXT_CN_DOC"] = "ADD_TEXT_CN_DOC";
    IContentDocActionTypes["ADD_ZML_ENTITY_CN_DOC"] = "ADD_ZML_ENTITY_CN_DOC";
    IContentDocActionTypes["ADD_ENTITY_CN_DOC"] = "ADD_ENTITY_CN_DOC";
    IContentDocActionTypes["ADD_SCENES_AT_INDEX_CN_DOC"] = "ADD_SCENES_AT_INDEX_CN_DOC";
    IContentDocActionTypes["COPY_SCENES_AT_INDEX_CN_DOC"] = "COPY_SCENES_AT_INDEX_CN_DOC";
    IContentDocActionTypes["LOCK_ENTITY_CN_DOC"] = "LOCK_ENTITY_CN_DOC";
    IContentDocActionTypes["SET_ENTITY_POSITIONS_CN_DOC"] = "SET_ENTITY_POSITIONS_CN_DOC";
    IContentDocActionTypes["SET_ENTITY_ROTATIONS_CN_DOC"] = "SET_ENTITY_ROTATIONS_CN_DOC";
    // SET_ENTITY_COLORS_CN_DOC = 'SET_ENTITY_COLORS_CN_DOC',
    IContentDocActionTypes["SET_SCALE_FACTORS_CN_DOC"] = "SET_SCALE_FACTORS_CN_DOC";
    IContentDocActionTypes["PASTE_COPIED_ENTITIES_CN_DOC"] = "PASTE_COPIED_ENTITIES_CN_DOC";
    IContentDocActionTypes["REMOVE_ENTITIES_CN_DOC"] = "REMOVE_ENTITIES_CN_DOC";
    IContentDocActionTypes["CHANGE_CN_DOC_REDUX"] = "CHANGE_CN_DOC_REDUX";
    IContentDocActionTypes["SET_COMPONENT_TRANSITION_CN_DOC"] = "SET_COMPONENT_TRANSITION_CN_DOC";
    IContentDocActionTypes["SET_COMPONENT_ACTION_CN_DOC"] = "SET_COMPONENT_ACTION_CN_DOC";
    IContentDocActionTypes["REMOVE_SCENE_REFERENCES_CN_DOC"] = "REMOVE_SCENE_REFERENCES_CN_DOC";
    IContentDocActionTypes["SET_MULTIPLE_COMPONENT_PROPS_CN_DOC"] = "SET_MULTIPLE_COMPONENT_PROPS_CN_DOC";
    IContentDocActionTypes["SET_MULTIPLE_COMPONENT_PROPS_CN_DOC_TEST"] = "SET_MULTIPLE_COMPONENT_PROPS_CN_DOC_TEST";
    IContentDocActionTypes["SET_IMAGE_TRACKING_CN_DOC"] = "SET_IMAGE_TRACKING_CN_DOC";
    IContentDocActionTypes["SET_ACTIVE_SCENE_CHILDREN"] = "SET_ACTIVE_SCENE_CHILDREN";
    IContentDocActionTypes["UNDO_CN_DOC"] = "UNDO_CN_DOC";
    IContentDocActionTypes["REDO_CN_DOC"] = "REDO_CN_DOC";
    IContentDocActionTypes["REMOVE_IMAGE_TRACKING_CN_DOC"] = "REMOVE_IMAGE_TRACKING_CN_DOC";
    IContentDocActionTypes["SET_ROOT_CHILDREN"] = "SET_ROOT_CHILDREN";
    IContentDocActionTypes["ADD_COMPONENT_ACTION_CN_DOC"] = "ADD_COMPONENT_ACTION_CN_DOC";
    IContentDocActionTypes["REMOVE_COMPONENT_ACTION_CN_DOC"] = "REMOVE_COMPONENT_ACTION_CN_DOC";
    IContentDocActionTypes["REPARENT_COMPONENT_CN_DOC"] = "REPARENT_COMPONENT_CN_DOC";
    IContentDocActionTypes["ADD_FACE_LANDMARK_TO_SCENE_CN_DOC"] = "ADD_FACE_LANDMARK_TO_SCENE_CN_DOC";
    IContentDocActionTypes["ADD_ANCHOR_GROUP_TO_SCENE_CN_DOC"] = "ADD_ANCHOR_GROUP_TO_SCENE_CN_DOC";
    IContentDocActionTypes["ADD_PROJECT_COLORS_CN_DOC"] = "ADD_PROJECT_COLORS_CN_DOC";
    IContentDocActionTypes["SET_EMITTER_PROPERTIES_CN_DOC"] = "SET_EMITTER_PROPERTIES_CN_DOC";
    IContentDocActionTypes["SET_EMITTER_GROUP_PROPERTIES_CN_DOC"] = "SET_EMITTER_GROUP_PROPERTIES_CN_DOC";
    IContentDocActionTypes["SET_EMITTER_BASE_PROPERTIES_CN_DOC"] = "SET_EMITTER_BASE_PROPERTIES_CN_DOC";
    IContentDocActionTypes["SET_TARGET_IMAGE_REFERENCE_OBJECT_CN_DOC"] = "SET_TARGET_IMAGE_REFERENCE_OBJECT_CN_DOC";
    IContentDocActionTypes["SET_CHROMA_KEY_PROPERTIES_CN_DOC"] = "SET_CHROMA_KEY_PROPERTIES_CN_DOC";
    IContentDocActionTypes["SET_PROJECT_SHADOWS_ENABLED_CN_DOC"] = "SET_PROJECT_SHADOWS_ENABLED_CN_DOC";
    IContentDocActionTypes["SET_ACTION_TRIGGER_CN_DOC"] = "SET_ACTION_TRIGGER_CN_DOC";
    IContentDocActionTypes["SET_DEVICE_CN_DOC"] = "SET_DEVICE_CN_DOC";
    IContentDocActionTypes["SET_SCENE_360_BACKGROUND"] = "SET_SCENE_360_BACKGROUND";
    IContentDocActionTypes["SET_SCENE_360_INITIAL_CAMERA_ROTATION"] = "SET_SCENE_360_INITIAL_CAMERA_ROTATION";
    IContentDocActionTypes["SET_VIDEO_RENDITION_PROGRESS_DATA"] = "SET_VIDEO_RENDITION_PROGRESS_DATA";
    IContentDocActionTypes["SET_LAUNCH_SCREEN_ID"] = "SET_LAUNCH_SCREEN_ID";
    IContentDocActionTypes["SET_LAUNCH_SCREEN_FIELD"] = "SET_LAUNCH_SCREEN_FIELD";
    IContentDocActionTypes["SET_GRAB_N_GO_OPTIONS"] = "SET_GRAB_N_GO_OPTIONS";
    IContentDocActionTypes["ADD_MEDIA_FILE"] = "ADD_MEDIA_FILE";
    IContentDocActionTypes["REMOVE_TRACKING_IMAGE_DATA_CN_DOC"] = "REMOVE_TRACKING_IMAGE_DATA_CN_DOC";
    IContentDocActionTypes["SET_IS_WEBXR_ENABLED_EXPERIENCE"] = "SET_IS_WEBXR_ENABLED_EXPERIENCE";
    IContentDocActionTypes["SET_SCREEN_RELATIVE_SCALE_TYPE"] = "SET_SCREEN_RELATIVE_SCALE_TYPE";
})(IContentDocActionTypes || (IContentDocActionTypes = {}));
export var IUserActionTypes;
(function (IUserActionTypes) {
    IUserActionTypes["SET_ACTIVE_EDITING_ACTION_DATA"] = "SET_ACTIVE_EDITING_ACTION_DATA";
    IUserActionTypes["SET_POPOUT_IDEAL_TOP_POSITION"] = "SET_POPOUT_IDEAL_TOP_POSITION";
    IUserActionTypes["SET_MULTIPLE_ENTITY_SELECT_BOUNDARY"] = "SET_MULTIPLE_ENTITY_SELECT_BOUNDARY";
    IUserActionTypes["SET_CHROMA_KEY_EDIT_MODAL_DATA"] = "SET_CHROMA_KEY_EDIT_MODAL_DATA";
    IUserActionTypes["SET_SELECTED_TEMPLATE_PROJECT"] = "SET_SELECTED_TEMPLATE_PROJECT";
    IUserActionTypes["SET_ACTIVE_ANIMATION_PRESET"] = "SET_ACTIVE_ANIMATION_PRESET";
    IUserActionTypes["SET_TARGET_IMAGE_REFERENCE_OBJECT_POSITION"] = "SET_TARGET_IMAGE_REFERENCE_OBJECT_POSITION";
    IUserActionTypes["SET_CURVATURES"] = "SET_CURVATURES";
    IUserActionTypes["SET_FILL_RGBA"] = "SET_FILL_RGBA";
    IUserActionTypes["SET_FONT_RGBA"] = "SET_FONT_RGBA";
    IUserActionTypes["SET_BORDER_RGBA"] = "SET_BORDER_RGBA";
    IUserActionTypes["SET_EMITTER_AREA_SCALES"] = "SET_EMITTER_AREA_SCALES";
    IUserActionTypes["OPEN_MODAL"] = "OPEN_MODAL";
    IUserActionTypes["CLOSE_MODAL"] = "CLOSE_MODAL";
    IUserActionTypes["SET_OPEN_SCENE_MENU_DRAWER"] = "SET_OPEN_SCENE_MENU_DRAWER";
    IUserActionTypes["SET_OPEN_PROJECT_MENU_DRAWER"] = "SET_OPEN_PROJECT_MENU_DRAWER";
    IUserActionTypes["SET_WEB_EMBED_PREVIEW_SETTINGS"] = "SET_WEB_EMBED_PREVIEW_SETTINGS";
    IUserActionTypes["SET_WEB_EMBED_EDITING_MODE"] = "SET_WEB_EMBED_EDITING_MODE";
    IUserActionTypes["SET_SELECTED_AUDIO"] = "SET_SELECTED_AUDIO";
    IUserActionTypes["ADD_TO_LOADED_AUDIO"] = "ADD_TO_LOADED_AUDIO";
    IUserActionTypes["SET_REPLACE_ENTITY_MODE"] = "SET_REPLACE_ENTITY_MODE";
    IUserActionTypes["SET_FILE_VERIFYING"] = "SET_FILE_VERIFYING";
    IUserActionTypes["SET_OPEN_ENTITY_MENU_CATEGORY_DRAWER"] = "SET_OPEN_ENTITY_MENU_CATEGORY_DRAWER";
    IUserActionTypes["SET_OPEN_ENTITY_MENU_DRAWER"] = "SET_OPEN_ENTITY_MENU_DRAWER";
    IUserActionTypes["SET_OPEN_INSPECTOR_MENU_ENTITY_SHELF"] = "SET_OPEN_INSPECTOR_MENU_ENTITY_SHELF";
    IUserActionTypes["SETUP_AUTOMERGE_SOCKET"] = "SETUP_AUTOMERGE_SOCKET";
    IUserActionTypes["CANVAS_IS_LOADED"] = "CANVAS_IS_LOADED";
    IUserActionTypes["SET_USER_ID"] = "SET_USER_ID";
    IUserActionTypes["UPDATE_USERS"] = "UPDATE_USERS";
    IUserActionTypes["SET_ACTIVE_SCENE"] = "SET_ACTIVE_SCENE";
    IUserActionTypes["SET_START_POS"] = "SET_START_POS";
    IUserActionTypes["GET_ALL_IMAGES"] = "GET_ALL_IMAGES";
    IUserActionTypes["SET_MARKER_INDEX_PRESSED"] = "SET_MARKER_INDEX_PRESSED";
    IUserActionTypes["SET_POSITIONING_ACTIVE"] = "SET_POSITIONING_ACTIVE";
    IUserActionTypes["SET_BACKGROUND_HOTSPOT_ENABLED"] = "SET_BACKGROUND_HOTSPOT_ENABLED";
    IUserActionTypes["SET_SCALE_HOTSPOT_ENABLED"] = "SET_SCALE_HOTSPOT_ENABLED";
    IUserActionTypes["SET_ROTATION_ACTIVE"] = "SET_ROTATION_ACTIVE";
    IUserActionTypes["SET_CLICK_OFFSET"] = "SET_CLICK_OFFSET";
    IUserActionTypes["SET_HOTSPOT_POINTER_MOVED"] = "SET_HOTSPOT_POINTER_MOVED";
    IUserActionTypes["SET_CURRENT_SCENE_INDEX"] = "SET_CURRENT_SCENE_INDEX";
    IUserActionTypes["SCROLL_SCENE_MENU"] = "SCROLL_SCENE_MENU";
    IUserActionTypes["SET_SCENE_SNAPSHOTS"] = "SET_SCENE_SNAPSHOTS";
    IUserActionTypes["ADD_ENTITY_IDS_TO_SELECTION"] = "ADD_ENTITY_IDS_TO_SELECTION";
    IUserActionTypes["REMOVE_SELECTION"] = "REMOVE_SELECTION";
    IUserActionTypes["REMOVE_ENTITIES"] = "REMOVE_ENTITIES";
    IUserActionTypes["REMOVE_LOCAL_USER_SELECTION"] = "REMOVE_LOCAL_USER_SELECTION";
    IUserActionTypes["CHANGE_ZOOM_LEVEL"] = "CHANGE_ZOOM_LEVEL";
    IUserActionTypes["DISABLE_REDO_BTN"] = "DISABLE_REDO_BTN";
    IUserActionTypes["DISABLE_UNDO_BTN"] = "DISABLE_UNDO_BTN";
    IUserActionTypes["SET_HOTKEY"] = "SET_HOTKEY";
    IUserActionTypes["REMOVE_HOTKEY"] = "REMOVE_HOTKEY";
    IUserActionTypes["SET_DRAG_SELECTION_ENABLED"] = "SET_DRAG_SELECTION_ENABLED";
    IUserActionTypes["SET_GROUP_INVERSION"] = "SET_GROUP_INVERSION";
    IUserActionTypes["COPY_SELECTED_ENTITIES"] = "COPY_SELECTED_ENTITIES";
    IUserActionTypes["SET_SELECTION_2D_POSITION"] = "SET_SELECTION_2D_POSITION";
    IUserActionTypes["SET_SELECTION_2D_TOP_LEFT_POSITION"] = "SET_SELECTION_2D_TOP_LEFT_POSITION";
    IUserActionTypes["SET_SELECTION_2D_TOP_RIGHT_POSITION"] = "SET_SELECTION_2D_TOP_RIGHT_POSITION";
    IUserActionTypes["SET_SELECTION_2D_BOTTOM_LEFT_POSITION"] = "SET_SELECTION_2D_BOTTOM_LEFT_POSITION";
    IUserActionTypes["SET_SELECTION_2D_BOTTOM_RIGHT_POSITION"] = "SET_SELECTION_2D_BOTTOM_RIGHT_POSITION";
    IUserActionTypes["SET_ROTATION_MARKER_2D_POSITION"] = "SET_ROTATION_MARKER_2D_POSITION";
    IUserActionTypes["SET_SCENE_ENTITY_LIST_VISIBLE"] = "SET_SCENE_ENTITY_LIST_VISIBLE";
    IUserActionTypes["SET_SNAPSHOT_DICT"] = "SET_SNAPSHOT_DICT";
    IUserActionTypes["SET_SCENE_CAROUSEL_SCROLL_LEFT"] = "SET_SCENE_CAROUSEL_SCROLL_LEFT";
    IUserActionTypes["SET_SCENE_MENU_LARGE"] = "SET_SCENE_MENU_LARGE";
    IUserActionTypes["FOCUS_SCENE_NAME_INPUT"] = "FOCUS_SCENE_NAME_INPUT";
    IUserActionTypes["SET_PROJECT_INFO"] = "SET_PROJECT_INFO";
    IUserActionTypes["SET_ENTITY_MENU_DRAG_ACTIVE"] = "SET_ENTITY_MENU_DRAG_ACTIVE";
    IUserActionTypes["SET_ENTITY_MENU_DRAG_HOTSPOT_POSITION"] = "SET_ENTITY_MENU_DRAG_HOTSPOT_POSITION";
    IUserActionTypes["SET_ENTITY_MENU_DRAG_INFO"] = "SET_ENTITY_MENU_DRAG_INFO";
    IUserActionTypes["SET_LOADED_AUDIO"] = "SET_LOADED_AUDIO";
    IUserActionTypes["SET_LOADED_360_BACKGROUND"] = "SET_LOADED_360_BACKGROUND";
    IUserActionTypes["LOADING_MEDIA"] = "LOADING_MEDIA";
    // ADD_TO_LOADED_MEDIA = 'ADD_TO_LOADED_MEDIA',
    IUserActionTypes["SET_AUDIO_STATUS"] = "SET_AUDIO_STATUS";
    IUserActionTypes["SET_CURRENT_UPLOADS"] = "SET_CURRENT_UPLOADS";
    IUserActionTypes["REMOVE_UPLOAD"] = "REMOVE_UPLOAD";
    IUserActionTypes["REMOVE_LOADED_MEDIA"] = "REMOVE_LOADED_MEDIA";
    IUserActionTypes["SET_TRACKING_IMG_DATA"] = "SET_TRACKING_IMG_DATA";
    IUserActionTypes["SET_TRACKING_IMG_UPLOADING"] = "SET_TRACKING_IMG_UPLOADING";
    IUserActionTypes["REMOVE_TRACKING_IMG_DATA"] = "REMOVE_TRACKING_IMG_DATA";
    IUserActionTypes["SET_PURE_REACT_IN_CANVAS_HOVERED"] = "SET_PURE_REACT_IN_CANVAS_HOVERED";
    IUserActionTypes["SET_SOCKET_CONNECTED"] = "SET_SOCKET_CONNECTED";
    IUserActionTypes["SET_PROJECT_LOADING_PROGRESS"] = "SET_PROJECT_LOADING_PROGRESS";
    IUserActionTypes["SET_PROJECT_LOADING_FAILURE"] = "SET_PROJECT_LOADING_FAILURE";
    IUserActionTypes["ADD_TOAST"] = "ADD_TOAST";
    IUserActionTypes["REMOVE_TOAST"] = "REMOVE_TOAST";
    IUserActionTypes["SET_SELECTED_ENTIY_IDS"] = "SET_SELECTED_ENTIY_IDS";
    IUserActionTypes["EDIT_SCENE_TITLE"] = "EDIT_SCENE_TITLE";
    IUserActionTypes["SET_3D_MODE"] = "SET_3D_MODE";
    IUserActionTypes["SET_SCREEN_RELATIVE_MODE"] = "SET_SCREEN_RELATIVE_MODE";
    IUserActionTypes["SET_TRANSFORM_CONTROLS_ACTIVE"] = "SET_TRANSFORM_CONTROLS_ACTIVE";
    IUserActionTypes["SET_TRANSFORM_CONTROLS_MODE"] = "SET_TRANSFORM_CONTROLS_MODE";
    IUserActionTypes["SET_SCREEN_RELATIVE_DEVICE"] = "SET_SCREEN_RELATIVE_DEVICE";
    IUserActionTypes["SET_SCREEN_RELATIVE_DEVICE_PREVIOUS_CUSTOM_DIMENSIONS"] = "SET_SCREEN_RELATIVE_DEVICE_PREVIOUS_CUSTOM_DIMENSIONS";
    IUserActionTypes["SET_MEDIA_LIBRARY_DISPLAY"] = "SET_MEDIA_LIBRARY_DISPLAY";
    IUserActionTypes["SET_TEMP_ANIMATE_MODEL_ACTION"] = "SET_TEMP_ANIMATE_MODEL_ACTION";
    IUserActionTypes["SET_VISIBLE_CANVAS"] = "SET_VISIBLE_CANVAS";
    IUserActionTypes["SET_POSITIONS"] = "SET_POSITIONS";
    IUserActionTypes["SET_SCALES"] = "SET_SCALES";
    IUserActionTypes["SET_ROTATIONS"] = "SET_ROTATIONS";
    IUserActionTypes["SET_ACTIVE_FACE_LANDMARK"] = "SET_ACTIVE_FACE_LANDMARK";
    IUserActionTypes["SET_SHOW_FACE_LANDMARKS"] = "SET_SHOW_FACE_LANDMARKS";
    IUserActionTypes["SET_HOVERED_FACE_LANDMARK_DROPDOWN"] = "SET_HOVERED_FACE_LANDMARK_DROPDOWN";
    IUserActionTypes["SET_EMITTER_IS_STATIC"] = "SET_EMITTER_IS_STATIC";
    IUserActionTypes["SET_PREVIEW_CODE_SRC"] = "SET_PREVIEW_CODE_SRC";
    IUserActionTypes["SET_PREVIEW_URL"] = "SET_PREVIEW_URL";
    IUserActionTypes["SET_DRAG_CONTROLS_UPDATE_TRIGGER"] = "SET_DRAG_CONTROLS_UPDATE_TRIGGER";
    IUserActionTypes["SET_TEMP_INITIAL_ROTATION"] = "SET_TEMP_INITIAL_ROTATION";
    IUserActionTypes["SET_VIDEO_RENDITION_PROGRESS"] = "SET_VIDEO_RENDITION_PROGRESS";
    IUserActionTypes["SET_SHOW_PUBLISH_POPUP"] = "SET_SHOW_PUBLISH_POPUP";
    IUserActionTypes["SET_PUBLISH_TRIGGER"] = "SET_PUBLISH_TRIGGER";
    IUserActionTypes["SET_PROJECT_SIZE_LIMIT"] = "SET_PROJECT_SIZE_LIMIT";
    IUserActionTypes["SET_PROJECT_SIZE"] = "SET_PROJECT_SIZE";
    IUserActionTypes["SET_SPINNER_COORDINATES"] = "SET_SPINNER_COORDINATES";
    IUserActionTypes["SET_PROJECT_DUPLICATING"] = "SET_PROJECT_DUPLICATING";
    IUserActionTypes["SET_SHOW_APP_CLIPS_MODAL"] = "SET_SHOW_APP_CLIPS_MODAL";
    IUserActionTypes["SET_PUBLISH_BTN_STATUS"] = "SET_PUBLISH_BTN_STATUS";
    IUserActionTypes["SET_PREVIEW_BTN_STATUS"] = "SET_PREVIEW_BTN_STATUS";
    IUserActionTypes["SET_APP_CLIPS_CONVERTED"] = "SET_APP_CLIPS_CONVERTED";
    IUserActionTypes["SET_UPDATE_TRIGGER"] = "SET_UPDATE_TRIGGER";
    IUserActionTypes["SET_ACTIVE_PREVIEW_TRACKING_IMAGE_INDEX"] = "SET_ACTIVE_PREVIEW_TRACKING_IMAGE_INDEX";
    IUserActionTypes["SET_WHATS_NEW_TRIGGER"] = "SET_WHATS_NEW_TRIGGER";
    IUserActionTypes["SET_IS_USER_AUTHORIZED"] = "SET_IS_USER_AUTHORIZED";
    IUserActionTypes["SET_LAUNCH_PAGE_ICON_FILESTORE_ID"] = "SET_LAUNCH_PAGE_ICON_FILESTORE_ID";
})(IUserActionTypes || (IUserActionTypes = {}));
export var IAddMediaPositionTypes;
(function (IAddMediaPositionTypes) {
    IAddMediaPositionTypes["start"] = "start";
    IAddMediaPositionTypes["end"] = "end";
    IAddMediaPositionTypes["date"] = "date";
})(IAddMediaPositionTypes || (IAddMediaPositionTypes = {}));
export var ILoadedMediaTypes;
(function (ILoadedMediaTypes) {
    ILoadedMediaTypes["image"] = "image";
    ILoadedMediaTypes["background360"] = "background360";
    ILoadedMediaTypes["model3d"] = "model3d";
    ILoadedMediaTypes["video"] = "video";
    ILoadedMediaTypes["audio"] = "audio";
    ILoadedMediaTypes["zpp"] = "zpp";
    ILoadedMediaTypes["trackingImage"] = "trackingImage";
    ILoadedMediaTypes["launchScreenIcon"] = "launchScreenIcon";
})(ILoadedMediaTypes || (ILoadedMediaTypes = {}));
